import Flickity from 'flickity/dist/flickity.pkgd';
import 'flickity-imagesloaded/flickity-imagesloaded';

export default {
  init() {
    // JavaScript to be fired on all pages

    // Look for .hamburger
    let hamburger = document.querySelector('.hamburger');
    let nav = document.querySelector('nav.nav-primary');
    let navOverlay = document.querySelector('.nav-overlay');
    // On click
    hamburger.addEventListener('click', function() {
      // Toggle class "is-active"
      hamburger.classList.toggle('is-active');
      nav.classList.toggle('open');
      navOverlay.classList.toggle('nav-open');
      // Do something else, like open/close menu
    });

    navOverlay.addEventListener('click', function(){
      hamburger.classList.toggle('is-active');
      nav.classList.toggle('open');
      navOverlay.classList.toggle('nav-open');
    });

    var header = document.querySelector('header.banner');

    window.addEventListener('scroll', function() {
      if (this.window.scrollY > 0) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    });

    const elem = document.querySelector('.slides');
  
    if(elem){
      let flkty = new Flickity(elem, {
        cellAlign: 'left',
        contain: true,
        adaptiveHeight: true,
        resize: true,
        cellSelector: '.item',
        // prevNextButtons: false,
        pageDots: false,
        autoPlay: 4000,
        pauseAutoPlayOnHover: true,
        imagesLoaded: true,
      });
  
      window.addEventListener('load', function(){
        flkty.resize();
      });
    }    

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js